import type { GetRecurringFeeChargesOneResponse } from '@Common/types/bo/recurring_fee_charges';

export const b2bRecurringFeeChargesTranslations = {
  title: 'B2B Recurring Fee Charges',
  sections: {
    details: 'Details',
    linked_orders: 'Fee charge orders',
    paid_by_company: 'Paid by Company',
    paid_by_user: 'Paid by Employee',
  },
  types: {
    b2b_custody_fee: 'Custody Fee',
    b2b_management_fee: 'Management Fee',
  } satisfies Record<GetRecurringFeeChargesOneResponse['type'], string>,
  statuses: {
    new: 'New',
    executed: 'Executed',
    insufficient_funds: 'Insufficient funds',
    initiated: 'Initiated',
    skipped: 'Skipped',
  } satisfies Record<GetRecurringFeeChargesOneResponse['status'], string>,
  paid_by_values: {
    company: 'Company',
    user: 'Employee',
  } satisfies Record<GetRecurringFeeChargesOneResponse['paid_by'], string>,
  charge_frequencies: {
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
  } satisfies Record<GetRecurringFeeChargesOneResponse['charge_frequency'], string>,
  fields: {
    id: 'Recurring fee ID',
    b2b_company_plan_type: 'Plan',
    user_id: 'User ID',
    paid_by: 'Paid by',
    type: 'Type',
    status: 'Status',
    amount_current_period: 'Amount charged for current period',
    charge_frequency: 'Charge frequency',
    amount_past_uncharged_periods: 'Amount charged for past, uncharged periods',
    date: 'Start Date',
    end_date: 'End Date',
    currency: 'Currency',
    created_at: 'Created At',
  } satisfies Record<keyof GetRecurringFeeChargesOneResponse, string>,
};
